import {
    GET_ANNOTATIONS_REQUEST,
    GET_ANNOTATIONS_SUCCESS,
    GET_ANNOTATIONS_FAILURE
} from '../actions';


const initialState = {};

const AnnotationsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ANNOTATIONS_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case GET_ANNOTATIONS_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: {...state.data, [action.request]: action.payload}});
        case GET_ANNOTATIONS_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default AnnotationsReducer;